export default __webpack_public_path__ + "static/media/3.cd63c93d.svg";